import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[provideNativeElement]',
  exportAs: 'element',
})
export class NativeElementHook {
  private readonly elementRef = inject(ElementRef);

  get element(): HTMLElement {
    return this.elementRef.nativeElement;
  }
}
